(function () {
  const block = {
    $block: document.querySelector('.hero_home_block'),
    init() {
      if (this.$block) {
        this.setUpListeners();
        this.setUpBgParallax();
        // this.initializeIntroAnimations();
      }
    },

    setUpListeners() {
      PubSub.subscribe('resize', () => {
        this.destroyBgParallax();
        this.setUpBgParallax();
      });
    },

    setUpBgParallax() {
      const blockRect = this.$block.getBoundingClientRect();
      let scrollerStartPos = blockRect.top + window.scrollY + blockRect.height;

      // make sure we start the parallax on a correct time no matter
      // how much of the screen it covers
      if (scrollerStartPos > window.innerHeight) {
        scrollerStartPos = window.innerHeight;
      }

      ScrollTrigger.create({
        // markers: true,
        id: 'home-parallax',
        trigger: this.$block,
        start: 'bottom top+='+scrollerStartPos+'',
        end: 'bottom top',
        onUpdate: (self) => {
          let amount = window.innerWidth * 0.1;
          let newAmount = amount * self.progress;

          if (window.innerWidth <= 768) {
            amount = window.innerWidth * 0.3;
            newAmount = amount * gsap.parseEase('power1.in')(self.progress);
          }

          gsap.set(this.$block.querySelector('.bg_wrapper'), {
            y: newAmount
          });
        }
      });

      // ScrollTrigger.refresh();
      ScrollTrigger.update();
    },

    destroyBgParallax() {
      const triggers = ScrollTrigger.getAll();

      triggers.forEach(trigger => {
        if (trigger.vars.id === 'home-parallax') {
          trigger.kill();
          console.log('Destroying home-parallax triggers');
        }
      });

      ScrollTrigger.refresh();
    },

    initializeIntroAnimations() {
      const $title = this.$block.querySelector('.content_wrapper > .title');
      const tl = gsap.timeline({});
      const totalDur = 1.2;

      this.nestedLinesSplit(
        $title,
        {
          type: 'lines',
          linesClass: 'line'
        }
      );

      gsap.set($title, {
        opacity: 1.0
      }, 0);

      // let's wait for the lines to be split
      tl.to(this.$block.querySelectorAll('.bg_img'), {
        opacity: 1.0,
        y: 0,
        duration: totalDur,
        ease: 'homeIntroEase'
      }, 0);

      tl.to($title.querySelectorAll('.title > .line > *'), {
        y: 0,
        duration: totalDur,
        ease: 'homeIntroEase'
      }, 0);

      tl.to(this.$block.querySelector('.content_wrapper > .desc'), {
        opacity: 1.0,
        duration: totalDur * 0.6666,
        ease: 'homeIntroEase'
      }, totalDur * 0.3333);

      tl.to(this.$block.querySelector('.content_wrapper > .links'), {
        opacity: 1.0,
        duration: totalDur * 0.3333,
        ease: 'homeIntroEase'
      }, totalDur * 0.6666);
    },

    nestedLinesSplit(target, vars) {
      target = gsap.utils.toArray(target);
      if (target.length > 1) {
        let splits = target.map(t => nestedLinesSplit(t, vars)),
            result = splits[0],
            resultRevert = result.revert;
        result.lines = splits.reduce((acc, cur) => acc.concat(cur.lines), []);
        result.revert = () => splits.forEach(s => s === result ? resultRevert() : s.revert());
        return result;
      }
      target = target[0];
      let contents = target.innerHTML;
      gsap.utils.toArray(target.children).forEach(child => {
        let split = new SplitText(child, {type: "lines"});
        split.lines.forEach(line => {
          let clone = child.cloneNode(false);
          clone.innerHTML = line.innerHTML;
          target.insertBefore(clone, child);
        });
        target.removeChild(child);
      });
      let split = new SplitText(target, vars),
          originalRevert = split.revert;
      split.revert = () => {
        originalRevert.call(split);
        target.innerHTML = contents;
      };
      return split;
    }
  };

  block.init();
})();
